import type { EntryMeta } from '~/types'
import Canvas from '~/components/Canvas'
import type { MediaPath } from '~/generated/media'

const cover = 'projects/merkel_wrapMagFinal2_detail.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'orbits',
	name: 'Orbits',
	excerpt: 'Nested rotating bodies trace a spirograph',
	tags: ['canvas', 'generative'],
	cover,
	order: 20,
}

export default function Orbits() {
	return (
		<div className="relative w-full h-[70vh] bg-black">
			<Canvas
				resizeToParent
				className="block w-full h-full"
				loop={(ctx, t) => {
					const { width, height } = ctx.canvas
					ctx.fillStyle = 'rgba(0,0,0,0.04)'
					ctx.fillRect(0, 0, width, height)
					const cx = width / 2
					const cy = height / 2
					const r = Math.min(width, height) / 4
					ctx.fillStyle = '#cc3366'
					for (let i = 0; i < 5; i += 1) {
						const a = t / 1000 + (i * Math.PI * 2) / 5
						const x = cx + Math.cos(a) * r + Math.cos(a * 5) * (r / 3)
						const y = cy + Math.sin(a) * r + Math.sin(a * 5) * (r / 3)
						ctx.beginPath()
						ctx.arc(x, y, 2.5, 0, Math.PI * 2)
						ctx.fill()
					}
				}}
			/>
		</div>
	)
}
